import React, { FC } from 'react'
import { PatternFormat } from 'react-number-format'
import {
  NumberFormatValues,
  PatternFormatProps,
} from 'react-number-format/types/types'
import { BtInputBase, BtInputBaseProps } from './BtInputBase'
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native'

export type BtNumberInputProps = BtInputBaseProps &
  Pick<PatternFormatProps, 'format'>

export const BtNumberInput: FC<BtNumberInputProps> = ({
  format,
  placeholder,
  size,
  label,
  value,
  disabled,
  validate,
  required,
  onChangeText,
  onBlur,
  testID,
  style,
}) => {
  const handleValueChange = (formatValues: NumberFormatValues) => {
    if (onChangeText) {
      onChangeText(formatValues.value)
    }
  }

  return (
    <PatternFormat
      format={format}
      placeholder={placeholder}
      size={size}
      label={label}
      value={value}
      disabled={disabled}
      required={required}
      customInput={BtInputBase}
      keyboardType="number-pad"
      allowEmptyFormatting={false}
      validate={validate}
      onValueChange={handleValueChange}
      onBlur={(e: any) => onBlur && onBlur(e)}
      valueIsNumericString
      testID={testID}
      style={style}
    />
  )
}
